import { Row } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { SEGMENTIO } from '../../../constants/segmentio';
import { EditableList, Input } from '../index';
import './Education.css';
import { validateStringOnly } from '../../../util/inputValidators';

function Education (props) {
  const handleValidation = (item) => {
    const getDate = (start_end) => {
      const month = item[`${start_end}_month`];
      const year = item[`${start_end}_year`];
      if (month && year) return moment(`${year}-${month}`, 'YYYY-MMMM');
      return null;
    };
    const start_date = getDate('start');
    const end_date = getDate('end');
    if (!item.level) item.error('level', 'Required field');
    if (!item.degree) item.error('degree', 'Required field');
    if (!item.college) item.error('college', 'Required field');
    if (!item.start_year) item.error('start_date', 'Required field');
    if (!item.end_year) item.error('end_date', 'Required field');

    if (item.college && !validateStringOnly(item.college)) {
      item.error('college', 'Special characters not allowed')
    }

    if (item.degree && !validateStringOnly(item.degree)) {
      item.error('degree', 'Special characters not allowed')
    }

    if (start_date & end_date) {
      if (moment(start_date.format('YYYY-MM-01')).isAfter(end_date.format('YYYY-MM-01'))) {
        item.error('start_date', 'Should be before or same as the end date');
        item.error('end_date', 'Should be after or same as the start date');
      }
    }
  };

  return (
    <EditableList
      {...props}
      onChange={props.onChange}
      textAddButton="Add Education"
      addEvent={SEGMENTIO.PROFILE_ADD_EDUCATION_EVENT_CLICKED}
      cancelEvent={SEGMENTIO.PROFILE_CANCEL_EDUCATION_EVENT_CLICKED}
      saveEvent={SEGMENTIO.PROFILE_SAVE_EDUCATION_EVENT_CLICKED}
      dataSource={props.educations || []}
      allowAdd
      addTitle="Add an education experience"
      editTitle="Update education experience"
      validation={handleValidation}
      renderForm={(item) => <EducationForm {...item} />}
      renderItem={(item, i) => <EducationItem {...item} key={i} />}
    />
  );
}

const EducationForm = React.memo((item) => {
  const listDegree = [
    'Bachelors (or equivalent)',
    'Doctorate (or equivalent)',
    'MBA (or equivalent)',
    'Masters (or equivalent)',
    'Secondary/High School (or equivalent)',
    'Other degree'
  ];
  const handleDateChange = (start_end) => (value) => {
    const month = `${start_end}_month`;
    const year = `${start_end}_year`;
    if (value) {
      item.set({
        [month]: value.format('MMMM'),
        [year]: value.format('YYYY')
      });
    } else {
      item.set({
        [month]: null,
        [year]: null
      });
    }
  };

  const handleReadDate = (start_end) => () => {
    const month = item[`${start_end}_month`];
    const year = item[`${start_end}_year`];
    if (month && year) return moment(`${year}-${month}`, 'YYYY-MMMM');
  };

  return (
    <Row gutter={[12, 0]}>
      <Input.Select
        span={24}
        label="Level of education"
        placeholder="Level of education"
        options={listDegree.map(value => ({ value, label: value }))}
        {...item.bind('level')}
      />
      <Input
        span={12}
        {...item.bind('degree', { defaultValue: '' })}
        label="Degree"
        placeholder="Degree"
      />
      <Input
        span={12}
        {...item.bind('college', { defaultValue: '' })}
        label="College"
        placeholder="College"
      />
      <Input.Month
        span={12}
        className="select-month"
        format="MMMM YYYY"
        {...item.bind('start_date', {
          onChange: handleDateChange('start'),
          onReadValue: handleReadDate('start')
        })}
        label="Start date"
      />
      <Input.Month
        span={12}
        className="select-month"
        format="MMMM YYYY"
        {...item.bind('end_date', {
          onChange: handleDateChange('end'),
          onReadValue: handleReadDate('end')
        })}
        label="End date"
      />
    </Row>
  );
});

const EducationItem = React.memo((props) => {
  const period = [];
  if (props.start_year) { period.push(`${!isNaN(Number(props.start_month)) ? '' : props.start_month} ${props.start_year}`.trim()); }
  if (props.end_year) { period.push(`${!isNaN(Number(props.end_month)) ? '' : props.end_month} ${props.end_year}`.trim()); }
  return (
    <div className="education-item" data-heap-redact-text>
      <small>{period.join(' - ')}</small>
      <h3>{props.college}</h3>
      <span>{props.degree}</span>
    </div>
  );
});

Education.propTypes = {
  onChange: PropTypes.func,
  educations: PropTypes.array
};

EducationItem.propTypes = {
  start_year: PropTypes.any,
  start_month: PropTypes.any,
  end_year: PropTypes.any,
  end_month: PropTypes.any,
  college: PropTypes.any,
  degree: PropTypes.any
};

export default Education;
